import { NextRequest, NextResponse } from 'next/server'
import { auth } from '@/auth'
import { db } from '@/db'
import { users } from '@/db/schema'
import { eq } from 'drizzle-orm'
import { DEFAULT_TIME_ZONE, isUserTimeZone } from '@/lib/user-time-zone'

export async function POST(req: NextRequest) {
  const session = await auth()
  if (!session?.user?.id) return NextResponse.json({ error: 'Unauthorized' }, { status: 401 })

  const body = await req.json().catch(() => null)
  const firstName = typeof body?.firstName === 'string' ? body.firstName.trim() : ''
  const lastName = typeof body?.lastName === 'string' ? body.lastName.trim() : ''
  const timeZone = typeof body?.timeZone === 'string' ? body.timeZone.trim() : DEFAULT_TIME_ZONE

  if (!firstName || !lastName) {
    return NextResponse.json({ error: 'firstName and lastName are required' }, { status: 400 })
  }
  if (!isUserTimeZone(timeZone)) {
    return NextResponse.json({ error: 'timeZone is invalid' }, { status: 400 })
  }

  await db
    .update(users)
    .set({ displayName: `${firstName} ${lastName}`, timeZone })
    .where(eq(users.id, session.user.id))

  return NextResponse.json({ ok: true })
}
